import { useEffect, useRef } from 'react';
import { RegistrationStatus } from '../../constants/Registration';
import { useAppDispatch, useAppSelector } from '../../store';
import { authActions } from '../../store/actions';

const REFRESH_INTERVAL_MS = 30000; // 30 seconds

/**
 * Hook to automatically refresh user data while registration is pending.
 * This ensures users see updated state without manual pull-to-refresh.
 */
export const useAutoRefreshWhilePending = () => {
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const isPending = currentUser?.registration?.status === RegistrationStatus.PENDING;

  useEffect(() => {
    if (isPending) {
      intervalRef.current = setInterval(() => {
        dispatch(authActions.fetchUser());
      }, REFRESH_INTERVAL_MS);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isPending, dispatch]);
};
